import { useCallback } from 'react';

export const useLaunchGameByCasino = () => {
    return useCallback((data) => {
        if (window.parent) {
            // in case game is launched from NGM CP or GDK
            window.parent.postMessage({
                _type: 'com.pt.casino.client.integration.overlay.OpenGameNotification',
                gameCode: data.code
            }, document.referrer || document.location.href);
        }
    }, []);
};
